'use strict'
const mapValues_ = require('lodash/mapValues')
const isEmpty_ = require('lodash/isEmpty')
const isFunction_ = require('lodash/isFunction')
const includes_ = require('lodash/includes')
const maybe = require('folktale/maybe')
const { getIncludes } = require('../dataset-controller/rootReducer')
const addComponentEventListener = require('./addComponentEventListener')

module.exports = ({ datasetApi, getState, errorBoundaries }) => {
  const includedReferences = getIncludes(getState())

  const flattenIncludedReferences = item =>
    mapValues_(item, (value, key) =>
      maybe
        .fromNullable({ key, value })
        .filter(({ value }) => !isEmpty_(value))
        .filter(({ value }) => isFunction_(value.get))
        .filter(({ key }) => includes_(includedReferences, key))
        .map(({ value }) => value.get())
        .getOrElse(value)
    )

  const getRows = fetch =>
    async function(startRow, endRow /*, sorting, filter*/) {
      const { items, totalCount } = await fetch(startRow, endRow - startRow)
      return {
        pageRows: items.map(flattenIncludedReferences),
        totalRowsCount: totalCount
      }
    }

  return {
    isValidContext() {
      return true
    },

    bindToComponent({ component: grid }, actions) {
      // Synchronously set initial data for SEO rendering
      actions.getInitialData().chain(({ items }) => {
        grid.rows = items.map(flattenIncludedReferences)
      })

      grid.dataFetcher = getRows(actions.fetch)

      addComponentEventListener(
        grid,
        'onCellSelect',
        ({ cellRowIndex }) => {
          datasetApi.setCurrentItemIndex(cellRowIndex)
        },
        errorBoundaries
      )

      addComponentEventListener(
        grid,
        'onRowSelect',
        ({ rowIndex }) => {
          datasetApi.setCurrentItemIndex(rowIndex)
        },
        errorBoundaries
      )
    },

    currentRecordModified({ component: grid }, actions, updatedFields) {
      grid.refresh()
    },

    recordSetLoaded({ component: grid }, actions) {
      grid.refresh()
    },

    currentViewChanged({ component: grid }, actions) {
      grid.refresh()
    },

    currentIndexChanged({ component: grid }, actions) {}
  }
}



// WEBPACK FOOTER //
// ./adapters/gridAdapter.js